import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadAssetsService, DownloadAssetsDialogComponent } from './download-assets.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ClientCoreModule } from '@thehubz/client/core';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, HttpClientModule, MatDialogModule, MatButtonModule, MatProgressBarModule, ClientCoreModule, MatIconModule],
  declarations: [DownloadAssetsDialogComponent],
  providers: [DownloadAssetsService],
})
export class ClientAssetServicesModule {}
